//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'CRUSADE',
  data() {
    return {
      form: {
        gender: '',
        hr: '',
        sys: '',
        hct: '',
        clear: '',
        cHF: '0',
        priorVascDis: '0',
        diabMellitus: '0',
      },
      hasScore: false,
      disabled: false,
      defaultJson: {
        "priorVascularDiseaseHint": "既往周围动脉疾病或既往脑卒中病史",
        "Heart Rate": "心率",
        "Systolic BP": "收缩压",
        "Baseline Hct": "Hct 基线",
        "Creat. Clearance": "肌酐清除率",
        "Diabetes Mellitus": "糖尿病",
        "Risk of Bleeding": "出血风险",
        "Signs of CHF at Presentation": "慢性心衰体征",
        "Prior Vascular Disease": "既往心血管疾病"
      },
      dataList1: [
        { value: "0", name: '男' },
        { value: "8", name: '女' },
      ],
      dataList2: [
        { value: "0", name: '透亮' },
        { value: "6", name: '絮状' },
        { value: "12", name: '粪质性' },
      ],
      major: 0,
      minor: 0
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算主要标准 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {

        // (priorVascDis ? 6 : 0) + (diabMellitus ? 6 : 0) + (cHF ? 7 : 0) + (gender.isFemale ? 8 : 0) +	(hct < 31 ? 9 : (hct < 34 ? 7 : (hct < 37 ? 3 : (hct < 40 ? 2 : 0)))) + (hr > 120 ? 11 : (hr > 110 ? 10 : (hr > 100 ? 8 : (hr > 90 ? 6 : (hr > 80 ? 3 : (hr > 70 ? 1 : 0)))))) + (sys > 200 ? 5 : (sys > 180 ? 3 : (sys > 120 ? 1 : (sys > 100 ? 5 : (sys > 90 ? 8 : 10))))) + (clear <= 15 ? 39 : (clear <= 30 ? 35 : (clear <= 60 ? 28 : (clear <= 90 ? 17 : (clear <= 120 ? 7 : 0)))))

        let result = (form.priorVascDis ? 6 : 0) + (form.diabMellitus ? 6 : 0) + (form.cHF ? 7 : 0) + form.gender + (form.hct < 31 ? 9 : (form.hct < 34 ? 7 : (form.hct < 37 ? 3 : (form.hct < 40 ? 2 : 0)))) + (form.hr > 120 ? 11 : (form.hr > 110 ? 10 : (form.hr > 100 ? 8 : (form.hr > 90 ? 6 : (form.hr > 80 ? 3 : (form.hr > 70 ? 1 : 0)))))) + (form.sys > 200 ? 5 : (form.sys > 180 ? 3 : (form.sys > 120 ? 1 : (form.sys > 100 ? 5 : (form.sys > 90 ? 8 : 10))))) + (form.clear <= 15 ? 39 : (form.clear <= 30 ? 35 : (form.clear <= 60 ? 28 : (form.clear <= 90 ? 17 : (form.clear <= 120 ? 7 : 0)))))
        self.hasScore = true
        return String(result)
      }


    },
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/CRUSADE.vue